import { Banker } from '../leads/types';
import {
  UserHierarchyApiResponse,
  UserPreferencesResponse,
  EtlInfoApiResponse,
  NameResolutionMap,
  LeadDataResolutionMap,
} from './types';

export type State = {
  userHierarchy: UserHierarchyApiResponse;
  userPreferences: UserPreferencesResponse;
  metaTeams: Array<string>;
  metaCountries: Array<string>;
  metaMarkets: Array<string>;
  etl: EtlInfoApiResponse;
  showSessionModal: boolean;
  clientNameResolutionMap: NameResolutionMap;
  clientNameResolutionLoading: boolean;
  containerNameResolutionMap: NameResolutionMap;
  containerNameResolutionLoading: boolean;
  collectionNameResolutionMap: NameResolutionMap;
  collectionNameResolutionLoading: boolean;
  leadsDataResolutionMap: LeadDataResolutionMap;
  leadsDataResolutionLoading: boolean;
  bankerNameResolutionMap: Banker[];
  bankerNameResolutionLoading: boolean;
};

export const state: State = {
  userHierarchy: {} as UserHierarchyApiResponse,
  userPreferences: {} as UserPreferencesResponse,
  metaTeams: [],
  metaCountries: [],
  metaMarkets: [],
  etl: {} as EtlInfoApiResponse,
  showSessionModal: false,
  clientNameResolutionMap: {},
  clientNameResolutionLoading: false,
  containerNameResolutionMap: {},
  containerNameResolutionLoading: false,
  collectionNameResolutionMap: {},
  collectionNameResolutionLoading: false,
  leadsDataResolutionMap: {},
  leadsDataResolutionLoading: false,
  bankerNameResolutionMap: [],
  bankerNameResolutionLoading: false,
};
